module.exports = __webpack_public_path__ + "static/media/sales.c4127b1c.svg";